export enum UsersOptions {
  BLOCK = 'Block',
  UNBLOCK = 'Unblock',
  BLOCK_IP = 'Block IP',
  UNBLOCK_IP = 'Unblock IP',
  CHANGE_ASSIGNED_COMPANY = 'Change Assigned Company',
  REMOVE_ASSIGNED_COMPANY = 'Remove Assigned Company',
  ADD_RANK = 'Add Rank',
  REMOVE_RANK = 'Remove Rank',
  ALLOW_QUOTE_RELEASE_WITHOUT_SENDING_EMAIL = 'Allow Quote Release Without Sending Email',
}
